import type { Module } from './models';

export const isNotLegacyModule = (expandedModule: Module) => !/old/i.exec(expandedModule.code);

export const moduleIsAvailableForSelection = (module: { code: string }) => {
    return ['Open discussion'].every(
        (ignoredCode) => module.code.toLowerCase() !== ignoredCode.toLowerCase(),
    );
};

// Business English modules, the only ones that still use old practice materials
const BUSINESS_ENGLISH_MODULE_IDS: ReadonlySet<number> = new Set([
    35, 36, 37, 46, 47, 48, 49, 50, 51,
]);

// Old practice materials are Easygenerator and H5P exercises
export const isOldPracticeEnabled = (moduleId: number) => BUSINESS_ENGLISH_MODULE_IDS.has(moduleId);
